<template>
  <div class="market-selection" v-if="markets.length > 1">
    <v-select
      id="market-select"
      v-model="selectedMarket"
      :items="markets"
      item-text="name"
      item-value="id"
      placeholder="Market"
      dense
      hide-details
      prepend-inner-icon="mdi-earth"
      aria-label="Select market"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MarketSelection",
  data() {
    return {
      isApplyingInitialSelection: false,
    };
  },
  methods: {
    async ensureInitialMarketSelection() {
      if (this.isApplyingInitialSelection) {
        return;
      }

      const markets = Array.isArray(this.markets) ? this.markets : [];
      if (markets.length === 0) {
        return;
      }

      const validMarketIds = markets.map((m) => (m && m.id ? m.id : null)).filter(Boolean);
      const selectedMarketId = this.$store.state.assetxpstate.selectedMarketId || null;
      if (selectedMarketId && validMarketIds.includes(selectedMarketId)) {
        return;
      }

      const profile = this.$store.state.authentication.user?.profile || {};
      const tokenSelectedMarket = profile.selected_market || null;
      const tokenDefaultMarket = profile["ixp_markets.defaultmarket"] || null;

      const resolvedMarketId =
        (tokenSelectedMarket && validMarketIds.includes(tokenSelectedMarket) && tokenSelectedMarket) ||
        (tokenDefaultMarket && validMarketIds.includes(tokenDefaultMarket) && tokenDefaultMarket) ||
        validMarketIds[0] ||
        null;

      if (!resolvedMarketId) {
        return;
      }

      this.isApplyingInitialSelection = true;
      try {
        await this.$store.dispatch("assetxpstate/selectMarket", resolvedMarketId);
      } catch (err) {
        console.warn("[MarketSelection] Failed to initialize market selection", {
          marketId: resolvedMarketId,
          error: err,
        });
      } finally {
        this.isApplyingInitialSelection = false;
      }
    },
  },
  computed: {
    ...mapGetters("authentication", ["hasMarketAccess"]),
    markets() {
      const list = this.$store.state.assetxpstate.markets || [];
      // Sort markets alphabetically by name
      return [...list].sort((a, b) => {
        if (!a || !a.name || !b || !b.name) return 0;
        return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
      });
    },
    selectedMarket: {
      get() {
        return this.$store.state.assetxpstate.selectedMarketId || null;
      },
      async set(marketId) {
        if (!marketId) return;
        if (marketId === this.$store.state.assetxpstate.selectedMarketId) return;

        try {
          await this.$store.dispatch("assetxpstate/selectMarket", marketId);
          
          // Navigate to home and reset state for user-initiated changes
          if (this.$route.path !== "/") {
            this.$router.push("/").catch(() => {});
          }
          await this.$store.dispatch("assetxpstate/ResetSelectedSection");
          await this.$store.dispatch("assetxpstate/ResetSelectedAsset");
        } catch (err) {
          console.warn("[MarketSelection] Failed to change market", { marketId, error: err });
        }
      }
    },
  },
  watch: {
    markets() {
      void this.ensureInitialMarketSelection();
    },
  },
  mounted() {
    this.$store.dispatch("assetxpstate/GetMyMarkets");
    void this.ensureInitialMarketSelection();
  },
};
</script>

<style scoped>
/* Keep minimal local styles; bulk is in styles/MarketSelection.scss */
</style>
